import React, { Component } from 'react';
import './styles/Loader.css';

export default class Loader extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mobileText: "Use +/- buttons to alter zoom level, touch and drag to rotate globe. Utilise 'Zoom Reset' button.",
            desktopText: "Use mouse wheel to change zoom level, or with two fingers, drag your trackpad to alter zoom level. Click and drag to rotate."
        }
    }

    componentDidMount() {
        setTimeout(() => {
            if(!sessionStorage.getItem('GlobalTotalCount') || !sessionStorage.getItem('CountriesTotalCount')
            || !sessionStorage.getItem('CountrySpecificData'))
            {
                this.setState({
                    mobileText: "Our data providers are currently experiencing some server issues, hence the site is temporarily out of service. Try refreshing after a few seconds.",
                    desktopText: "Our data providers are currently experiencing some server issues, hence the site is temporarily out of service. Try refreshing after a few seconds."
                })
            }
        }, 25000) 
    }

    render() {
        return (
            <div id="loaderWrapper">
                <h2 id='loader-tutorial'>
                    
                    {
                        window.screen.width < 768 ? 

                        // "Use +/- buttons to alter zoom level, touch and drag to rotate globe. Utilise 'Zoom Reset' button."
                        this.state.mobileText

                        :
                        // "Use mouse wheel to change zoom level, or with two fingers, drag your trackpad to alter zoom level. Click and drag to rotate."
                        this.state.desktopText
                    }
                </h2>
                <div className="spinner2">
                    <div className="double-bounce1"></div>
                    <div className="double-bounce2"></div>
                </div>
            </div>
        )
    }
}
